<template>
  <div :class="[`view-294-1 poppins-normal-storm-dust-14px`, className || ``]">
    <view5 :className="view5Props.className" />
    <div class="text-147">(25 отзывов)</div>
    <div class="text-148">4,5</div>
  </div>
</template>

<script>
import View5 from "./View5";
export default {
  name: "View372",
  components: {
    View5,
  },
  props: ["className", "view5Props"],
};
</script>

<style>
.view-294-1 {
  height: 25px;
  margin-top: 23.8px;
  position: relative;
  width: 267px;
}

.text-147 {
  left: 169px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.text-148 {
  left: 139px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.view-294-1.view-295,
.view-294-1.view-302 {
  margin-top: 6px;
}

.view-294-1.view-304,
.view-294-1.view-305 {
  height: 25px;
  left: 91px;
  position: absolute;
  top: 447px;
  width: 267px;
}

.view-294-1.view-303 {
  margin-top: 23px;
}
</style>
